import React from 'react'
import TopSec from '../../Component/Savings/Topsec'
import Save from '../../Component/Savings/Save'
import Why from '../../Component/Savings/Why'
import SavingPods from '../../Component/Savings/SavingPods'
import Stash from '../../Component/Savings/Stash'
import Seo from '../../Component/Seo'

function Savings() {
  return (
    <div>
      <Seo
        title='Halal Savings App for Goals and Group Saving | Halal Wealth'
        description='Save for Umrah, emergency funds, and life goals with halal savings products. Build disciplined, riba-free savings plans with Halal Wealth.'
        pathname='/savings'
      />
      <TopSec />
      {/* <SavingPods /> */}
      <Why />
      <Stash />
      <Save />
      
      
    </div>
  )
}

export default Savings
